const filterData = [
  { id: 1, title: "All" },
  { id: 2, title: "React.JS" },
  { id: 3, title: "Angular" },
  { id: 4, title: "Node.JS" },
  { id: 5, title: "HTML/CSS/JS" },
];

export default filterData;
